import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationStart, Router, RouterOutlet } from '@angular/router';
import { filter, timer, switchMap } from 'rxjs';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import './shared/extensions';
import { environment } from '../environments/environment';
import { SpinnerComponent } from './shared/components/spinner/spinner.component';
import { HeaderComponent } from './core/components/header/header.component';
import { ToastComponent } from './shared/components/toast/toast.component';
import { AuthService } from './core/services';
import { ROLE } from './shared/enums';
import { UtenteDettaglio } from './auth/utente.model';

@Component({
	selector: 'app-root',
	standalone: true,
	imports: [
		CommonModule,
		RouterOutlet,
		TranslateModule,
		SpinnerComponent,
		HeaderComponent,
		ToastComponent
	],
	templateUrl: './app.component.html',
	styleUrl: './app.component.scss'
})
export class AppComponent {
	title = 'futura_webapp';
	userLogged?: UtenteDettaglio;
	ROLE_TYPE = ROLE;

	private isFirstLoad = true;
	private currentRoute: string;

	constructor(
		private authService: AuthService,
		private router: Router,
		private translate: TranslateService
	) {
		this.router.events
			.pipe(filter(event => event instanceof NavigationStart))
			.subscribe((event: any) => (this.currentRoute = event.url));

		// Refresh user logged data every 5 minutes
		timer(0, 300000)
			.pipe(switchMap(() => this.authService.autoLogin()))
			.subscribe(response => this.onAutoLogin(response.data));

		this.authService.userLogged.subscribe(user => {
			if (!user) return;

			this.userLogged = user;

			if (user) {
				this.translate.use(user.cultureInfoCode ?? environment.locale);
			}
		});

		this.translate.use(environment.locale);
	}

	private onAutoLogin(user: UtenteDettaglio) {
		if (this.isFirstLoad) {
			this.isFirstLoad = false;

			if (!!this.currentRoute && this.currentRoute === '/') {
				this.authService.goToHomePage();
			}
		}
	}
}
